<template>
  <aside class="part-navigator">
    <div class="part-nav-title">
      <strong>待核对零件</strong>
      <span>{{ parts.length }} 个零件</span>
    </div>
    <button
      v-for="(part, index) in parts"
      :key="part.clientPartId || part.id || index"
      type="button"
      :class="['part-nav-item', { 'is-active': index === activeIndex, 'is-processing': part.parseStatus === 'processing' }]"
      @click="$emit('change', index)"
    >
      <span class="part-index">{{ index + 1 }}</span>
      <img :src="cover(part)" alt="">
      <em v-if="part.parseStatus === 'processing'" class="is-processing-badge">处理中</em>
      <em v-else-if="part.parseStatus === 'failed'">待补全</em>
    </button>
  </aside>
</template>

<script>
import defaultPartCover from '@/assets/image/common/default_rfq_thumb.png';
import { getImagePreview } from '@/utils/product-case/model';

export default {
  name: 'PartNavigator',
  props: {
    parts: {
      type: Array,
      default: () => []
    },
    activeIndex: {
      type: Number,
      default: 0
    }
  },
  methods: {
    cover(part) {
      const list = part.productPictureList || [];
      const target = list.find(item => item.selectedHashCode === part.defaultPhoto) || list[0] || {};
      return getImagePreview(target) || defaultPartCover;
    }
  }
};
</script>

<style lang="scss" scoped>
.part-navigator {
  width: 150px;
  max-height: calc(100vh - 96px);
  padding: 12px 0 24px;
  overflow-y: auto;
  background: transparent;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.part-navigator::-webkit-scrollbar {
  display: none;
}
.part-nav-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.part-nav-title strong {
  color: #061b3b;
  font-size: 14px;
  font-weight: 900;
}
.part-nav-title span {
  color: #62738c;
  font-size: 12px;
  font-weight: 700;
}
.part-nav-item {
  position: relative;
  width: 122px;
  height: 122px;
  display: block;
  margin: 0 auto 20px;
  padding: 7px;
  border: 1px solid #cbd9ea;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 12px 30px rgba(41, 72, 113, .04);
  cursor: pointer;
}
.part-nav-item.is-active {
  border-color: #4778ff;
  box-shadow: 0 0 0 3px rgba(52, 101, 255, .16), 0 16px 34px rgba(42, 86, 188, .16);
}
.part-nav-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
}
.part-index {
  position: absolute;
  z-index: 1;
  left: 10px;
  top: 10px;
  width: 24px;
  height: 22px;
  display: grid;
  place-items: center;
  border-radius: 6px;
  color: #fff;
  background: #344058;
  font-size: 14px;
  font-weight: 900;
}
em {
  position: absolute;
  right: 10px;
  bottom: 10px;
  padding: 2px 6px;
  border-radius: 999px;
  background: #fff2de;
  color: #c46a13;
  font-style: normal;
  font-size: 12px;
}

.part-nav-item.is-processing img {
  opacity: .55;
}
em.is-processing-badge {
  background: #eef5ff;
  color: #1d4ed8;
}
</style>
